<template>
  <table 
  ref="table"
  :class="['simple-table', {'hscroll': showLeftBorder}]">
    <slot></slot>
    <div ref="dragLineContainer">
      <template v-if="mounted">
        <div 
        v-for="(width, index) in colWidths" 
        :key="index"
        :style="{left: getLeftOffset(index) + 'px'}"
        class="drag-line"
        @mousedown="mouseDownHeader(index, $event)"
        @mouseup="mouseUp(index, $event)">
        </div>
      </template>
    </div>
  </table>
</template>

<script>
import Vue from 'vue'
import ScrollParent from 'scrollparent'

export default {
  props: {
    scrollParent: {
      default: null
    },
    colWidths: {
      default: () => []
    }
  },
  data () {
    return {
      cols: null,
      mounted: false,
      showLeftBorder: false,
      drag: {
        dragging: false,
        startX: 0,
        startWidth: 0,
        distance: 0,
        index: null,
        startTime: 0
      },
      localScrollParent: this.scrollParent,
      leftScrollOffset: 0
    }
  },
  watch: {
    colWidths (nv) {
      for (const[index, width] of nv.entries()) {
        this.cols[index].style.width = width + 'px'
      }
    }
  },
  methods: {
    getLeftOffset (index) {
      var accumulatedOffset = this.colWidths.reduce((a, i, curIndex) => {
        if (curIndex <= index) {
          a += i
        }
        return a
      }, -5)
      if (index === 0) {
        accumulatedOffset += this.leftScrollOffset
      }
      return accumulatedOffset
    },
    mouseDownHeader (index, e) {
      // @click="$refs['header' + index][0].style.width = '200px'"
      this.drag.dragging = true
      this.drag.startTime = Date.now()
      this.drag.distance = 0
      this.drag.index = index
      this.drag.startX = e.pageX
      // var cell = e.target ? e.target : e.srcElement
      this.drag.startWidth = this.colWidths[index]
    },
    mouseUp (index, e) {
      this.drag.dragging = false
      this.drag.index = null
    },
    onMouseMove (e) {
      if (this.drag.dragging) {
        var distance = this.drag.startWidth + (e.pageX - this.drag.startX)
        this.drag.distance = Math.abs(this.drag.startX - e.pageX)
        if (distance < 20) { // minimum cell width (should be positive)
          distance = 20
        }
        Vue.set(this.colWidths, this.drag.index, distance)
        // this.colWidths[this.drag.index - 1] = distance
        // this.$refs.colgroup.children[this.drag.index + 1].style.width = distance + 'px'
        /* if (this.drag.index === 0) {
          var cool = this.$refs.headerToolCol.clientWidth + distance - 1
          this.$refs.leftColShadow1.style.left = cool + 'px'
          this.$refs.leftColShadow2.style.left = cool + 'px'
        } */
      }
    },
    onScroll (e) {
      this.leftScrollOffset = e.target.scrollLeft
      if (e.target.scrollLeft > 0) {
        this.showLeftBorder = true
      } else {
        this.showLeftBorder = false
      }
    }
  },
  mounted () {
    if (this.localScrollParent === null) {
      this.localScrollParent = ScrollParent(this.$el)
    }
    this.localScrollParent.addEventListener('scroll', this.onScroll)
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('mouseup', this.mouseUp)
    this.cols = this.$refs.table.children[0].children
    /* 
    for (var i = 0; i < this.cols.length; i++) {
      this.colWidths.push(150)
      this.cols[i].style.width = '150px'
    } */
    for (const[index, width] of this.colWidths.entries()) {
      this.cols[index].style.width = (typeof width === 'string' ? width: width + 'px')
    }
    // this.cols[0].style.width = '300px'
    // this.colWidths[0] = 300
    this.mounted = true
  }
}
</script>

<style scoped lang="scss">
.simple-table {
  table-layout: fixed;
  width: 100%;
  /* Width is essential to allow colgroups to define cell width */
  border-collapse: collapse;
  border-spacing: 0px;
  position: relative;

  &.hscroll {
    & .drag-line:nth-child(1) {
      &:after {
        content: "";
        height: 100%;
        position: absolute;
        width: 8px;
        left: 4px;
        background: linear-gradient(to right, RGBA(57, 97, 120, 0.2), transparent)
      }
    }
  }

  & ::v-deep tr {
    /* height: 60px; */
    border-bottom: 1px solid var(--v-hline-base);
    height: 60px;
  }

  & ::v-deep th {
    text-align: left;
    padding-left: 8px;
    padding-right: 8px;
    text-overflow: ellipsis;
    font-weight: 400;
    overflow: hidden;
    font-family: 'Open Sans',Roboto,Arial,sans-serif;
    letter-spacing: .04785714em;
  }
  & ::v-deep td {
    min-width: 100px;
    padding-left: 8px;
    padding-right: 8px;
    overflow: hidden;
    text-overflow: ellipsis;

    & .crx-input::before {
      content: none;
    }
    & .crx-input {
      margin-top: 0px;
    }
  }
  /* & tr:nth-child(odd) {
    background: var(--v-background-darken1);

    & ::v-deep .sticky-col {
      background: var(--v-background-darken1);
    }
  } */
  & ::v-deep .sticky-col {
    position: sticky;
    left: 0px;
    background: white;
    z-index: 2;
  }

  & .drag-line:nth-child(1) {
    z-index: 3;
  }
  & .drag-line {
    position: absolute;
    height: 100%;
    top: 0px;
    left: 300px;
    width: 10px;
    z-index: 1;
    cursor: e-resize;
    -webkit-user-select: none; /* Safari */        
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */

    &:hover {
      background: var(--v-color1-base);
      opacity: 0.5;
      &:after {
        background: var(--v-color1-base);
      }
    }
    &:after {
      content: "";
      height: 100%;
      position: absolute;
      width: 1px;
      left: 5px;
      background: var(--v-hline-base);
    }
  }
}
</style>
